"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ListUnit = exports.CopyUnit = exports.DeleteUnit = exports.Alert = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var FileCopy_1 = __importDefault(require("@material-ui/icons/FileCopy"));
var Delete_1 = __importDefault(require("@material-ui/icons/Delete"));
var GetApp_1 = __importDefault(require("@material-ui/icons/GetApp"));
var copyToClipboard = function (e) {
    navigator.clipboard.writeText(e);
};
var getLink = function (uuid, contentType, prefix) {
    if (contentType === 'application/pdf') {
        return prefix + '/' + uuid + '/preview';
    }
    return prefix + '/' + uuid + '/serve';
};
var Preview = function (props) {
    var name = props.name, contentType = props.contentType, link = props.link;
    if (contentType.includes('image')) {
        return (react_1["default"].createElement(core_1.ListItemAvatar, null,
            react_1["default"].createElement(core_1.Avatar, { variant: 'square', alt: name, src: link })));
    }
    return (react_1["default"].createElement(core_1.ListItemIcon, null,
        react_1["default"].createElement(GetApp_1["default"], null)));
};
exports.Alert = function (props) {
    var children = props.children, loading = props.loading;
    if (loading === false) {
        return null;
    }
    return (react_1["default"].createElement("p", null,
        react_1["default"].createElement("i", null, children)));
};
exports.DeleteUnit = function (props) {
    var deleteFunc = props.deleteFunc, uuid = props.uuid;
    if (!deleteFunc) {
        return null;
    }
    return (react_1["default"].createElement(core_1.IconButton, { edge: "end", "aria-label": "delete", onClick: function () { return deleteFunc(uuid); } },
        react_1["default"].createElement(Delete_1["default"], null)));
};
exports.CopyUnit = function (props) {
    var link = props.link;
    if (!props.show) {
        return null;
    }
    return (react_1["default"].createElement(core_1.IconButton, { onClick: function () { return copyToClipboard(link); } },
        react_1["default"].createElement(FileCopy_1["default"], null)));
};
exports.ListUnit = function (props) {
    var prefix = props.prefix, uuid = props.uuid, name = props.name, _a = props.contentType, contentType = _a === void 0 ? 'application/text' : _a, onDelete = props.onDelete, _b = props.showCopy, showCopy = _b === void 0 ? false : _b;
    var link = getLink(uuid, contentType, prefix);
    return (react_1["default"].createElement(core_1.ListItem, { alignItems: "flex-start" },
        react_1["default"].createElement("a", { target: "_blank", rel: "noopener noreferrer", href: link },
            react_1["default"].createElement(Preview, { link: link, name: name, contentType: contentType })),
        react_1["default"].createElement(core_1.ListItemText, { primary: name, secondary: null }),
        react_1["default"].createElement(core_1.ListItemSecondaryAction, null,
            react_1["default"].createElement(exports.CopyUnit, { show: showCopy, link: link }),
            react_1["default"].createElement(exports.DeleteUnit, { deleteFunc: onDelete, uuid: uuid }))));
};
